import { UserOutline } from 'src/components/Icons/UserOutline'

import LoginDropdown from '../LoginDropdown/LoginDropdown'
import { ButtonIcon } from '../ButtonIcon'

interface LoginIconProps {
  showLoginDropdown: boolean

  onClick: () => void
  badgeConfig?: {
    badgeValue: string
    badgeColor: string
    badgeTextColor: string
  }
}

export const LoginButton = ({
  showLoginDropdown,
  onClick,
  badgeConfig,
}: LoginIconProps) => {
  return (
    <>
      <div className="bg-white">
        <ButtonIcon onClick={onClick} enableHover {...badgeConfig}>
          <UserOutline
            aria-label="Botão para redirecionar para a pagina de my-account"
            data-testid="user-icon-button"
          />
        </ButtonIcon>
      </div>

      {showLoginDropdown && (
        <LoginDropdown className="absolute top-full shadow-dropCard left-1/2 bg-white rounded-lg min-w-[202px] -translate-x-1/2 z-10 restructure-small-desktop:top-14 restructure-small-desktop:left-[94%]" />
      )}
    </>
  )
}
